module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "flat": ""
          }
        }, on), [_vm._v("\n      Create\n      "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [(_vm.hasPrivate) ? [_vm._l((_vm.privateProducts), function(product) {
    return _c('v-list-tile', {
      key: product.id,
      attrs: {
        "to": ("/create/" + (product.id))
      }
    }, [_vm._v("\n        " + _vm._s(product.name) + "\n      ")])
  }), _vm._v(" "), _c('v-divider')] : _vm._e(), _vm._v(" "), _vm._l((_vm.publicProducts), function(product) {
    return _c('v-list-tile', {
      key: product.id,
      attrs: {
        "to": ("/create/" + (product.id))
      }
    }, [_vm._v("\n      " + _vm._s(product.name) + "\n    ")])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6508fe5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/create-menu.vue
// module id = 800
// module chunks = 1